import { Component } from '@angular/core';
import { EnumMeasureTypes, EnumScales } from '@library/store/measures/measures.interface';
import { isDefined } from '@library/utils/helpers/store/is-defined';
import { LangPipe } from '@library/utils/pipes/lang.pipe';
import { getMonthText } from '@pages/control-page/control-page-main/control-page-reports/control-page-reports.service';
import { EnergyReportsFacade } from '@store/energy-reports/energy-reports.facade';
import { combineLatest } from 'rxjs';
import { CpReportsScaleService } from '../../cp-reports-month-viewer/cp-reports-scale-selector/cp-reports-scale.service';

@Component({
  selector: 'app-cp-reports-factors-internal-temperature',
  templateUrl: './cp-reports-factors-internal-temperature.component.html',
  styleUrls: ['./cp-reports-factors-internal-temperature.component.scss']
})
export class CpReportsFactorsInternalTemperatureComponent {
  Math = Math;
  report$ = this.energyReportsFacade.currentReport$.pipe(isDefined());

  viewModel$ = combineLatest({
    report: this.report$,
    scale: this.cpReportsScaleService.scale$,
  });

  EnumScales = EnumScales;
  EnumMeasureTypes = EnumMeasureTypes;

  constructor(
    private cpReportsScaleService: CpReportsScaleService,
    private energyReportsFacade: EnergyReportsFacade,
    private langPipe: LangPipe,
  ) {}

  getOperator(data: number) {
    return data > 0 ? this.langPipe.transform('common-app.__HIGHER') : this.langPipe.transform('common-app.__LOWER');
  }

  getMonth(month: number, year: number) {
    return getMonthText(month, year);
  }

}
